// Karmagick, L'essenziale: testata su una riga dove ci sta, scheda a voci, luna incisa sulla carta,
// carte dentro il negozio, lettura astrologica. Testi e indirizzi arrivano da snippets/kg-essenziale-testa.liquid.
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  /* I testi tradotti arrivano da Liquid con gli apostrofi in HTML: qui finiscono in textContent */
  const areaTesto = document.createElement('textarea');
  const inChiaro = (v) => {
    if (typeof v === 'string') { areaTesto.innerHTML = v; return areaTesto.value; }
    if (v && typeof v === 'object') return Object.fromEntries(Object.entries(v).map(([k, x]) => [k, inChiaro(x)]));
    return v;
  };
  const E = inChiaro(window.KG_ESS || {});
  const C = globalThis.KG_CIELO;

  /* Il percorso non ripete due volte la stessa parola */
  $$('.kg-trail__list').forEach((ol) => {
    const li = [...ol.children];
    for (let i = li.length - 1; i > 0; i--) if (li[i].textContent.trim() === li[i - 1].textContent.trim()) li[i - 1].remove();
  });

  /* Testata su una riga solo se il menu ci sta: in tedesco o su schermi più stretti restano due righe */
  const voci = $$('.header-menu .menu-list__link').filter((e) => e.getBoundingClientRect().width > 0);
  const larghezza = voci.reduce((s, e) => s + e.getBoundingClientRect().width, 0) * 13 / 14;
  if (voci.length && larghezza <= innerWidth - 445) {
    document.documentElement.classList.add('kg-ess-riga');
    /* La ricerca diventa un'icona a destra: il campo si apre al clic come sempre */
    const destra = $('.header__column--right');
    const cerca = $('.header__column--center search-button');
    if (destra && cerca) destra.prepend(cerca);
  }

  /* La descrizione a voci: la prima parte aperta, il resto a portata di tocco */
  const rte = $('.product-details rte-formatter[class*="descrizione"]');
  if (rte) {
    const nuove = document.createElement('div');
    let corrente = null;
    const apri = (titolo, aperta) => {
      const d = document.createElement('details'); d.className = 'kg-ess-voce'; d.open = aperta;
      const s = document.createElement('summary'); s.textContent = titolo;
      d.append(s, document.createElement('div')); nuove.append(d);
      return d.lastElementChild;
    };
    for (const f of [...rte.children]) {
      const titolo = /^(H[1-6])$/.test(f.tagName) || (f.tagName === 'P' && f.children.length === 1 && f.firstElementChild.tagName === 'STRONG' && f.textContent.length < 40);
      if (titolo) { const t = f.textContent.trim(); corrente = apri(t === t.toUpperCase() && !document.documentElement.lang.startsWith('de') ? t.toLowerCase().replace(/^./, (c) => c.toUpperCase()) : t, false); }
      else { if (!corrente) corrente = apri(E.descrizione || '', true); corrente.append(f); }
    }
    if (nuove.children.length) rte.replaceChildren(nuove);
  }

  /* Luna incisa: la foto vera della luna letta come rilievo e stampata a tratteggio, con la fase vera */
  function lunaIncisa(cv) {
    const gl = cv.getContext('webgl2', { alpha: true, premultipliedAlpha: true, preserveDrawingBuffer: true });
    if (!gl || !E.rilievo) return null;
    const crea = (t, s) => { const o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); return o; };
    const p = gl.createProgram();
    gl.attachShader(p, crea(gl.VERTEX_SHADER, `#version 300 es
      void main(){ vec2 v = vec2((gl_VertexID << 1) & 2, gl_VertexID & 2); gl_Position = vec4(v * 2. - 1., 0., 1.); }`));
    gl.attachShader(p, crea(gl.FRAGMENT_SHADER, `#version 300 es
      precision highp float;
      uniform vec2 ris; uniform float ang; uniform sampler2D tex; out vec4 o;
      void main(){
        vec2 f = gl_FragCoord.xy, p = f / ris * 2. - 1.; p *= 1.015;
        float r = length(p); float bordo = 1. - smoothstep(.992, 1., r);
        if (bordo <= 0.) { o = vec4(0.); return; }
        vec3 n = vec3(p, sqrt(max(0., 1. - r * r))), L = vec3(sin(ang), 0., -cos(ang));
        float lam = max(dot(n, L), 0.);
        vec2 uv = .5 + (n.xy / (1. + n.z * .32)) * .49; uv.y = 1. - uv.y;
        float h = texture(tex, uv).r, hb = textureLod(tex, uv, 3.).r;
        float luce = smoothstep(0., .08, dot(n, L) + (h - hb) * .3);
        float t = clamp((h * 1.45 + (h - hb) * 1.9) * (.2 + pow(lam, .55)) * luce, 0., 1.);
        float per = max(ris.y / 170., 3.);
        float a = abs(fract(dot(f, vec2(.707, .707)) / per) - .5) * 2.;
        float b = abs(fract(dot(f, vec2(-.707, .707)) / per) - .5) * 2.;
        float tt = mix(.3, clamp(t * 1.08 + .1, 0., 1.), smoothstep(.0, .22, luce * lam));
        float i1 = smoothstep(tt * 1.15 - .1, tt * 1.15 + .1, a);
        float i2 = (t < .36 && luce > .5) ? smoothstep(t * 3. - .1, t * 3. + .1, b) : 0.;
        float ink = max(i1, i2);
        ink = max(ink, smoothstep(.975, .985, r));
        vec3 c = vec3(.2, .09, .17);
        o = vec4(c * ink * bordo, ink * bordo);
      }`));
    gl.linkProgram(p);
    if (!gl.getProgramParameter(p, gl.LINK_STATUS)) return null;
    gl.useProgram(p);
    gl.bindVertexArray(gl.createVertexArray());
    const ang = gl.getUniformLocation(p, 'ang'), ris = gl.getUniformLocation(p, 'ris');
    let pronto = false, ultimo = 0;
    const disegna = (a = ultimo) => {
      ultimo = a; if (!pronto) return;
      const d = Math.min(devicePixelRatio || 1, 2), b = cv.getBoundingClientRect();
      cv.width = Math.max(2, Math.round(b.width * d)); cv.height = Math.max(2, Math.round(b.height * d));
      gl.viewport(0, 0, cv.width, cv.height); gl.uniform2f(ris, cv.width, cv.height); gl.uniform1f(ang, a);
      gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT); gl.drawArrays(gl.TRIANGLES, 0, 3);
    };
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      gl.bindTexture(gl.TEXTURE_2D, gl.createTexture());
      gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);
      gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, img);
      gl.generateMipmap(gl.TEXTURE_2D);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
      pronto = true; disegna();
    };
    img.src = E.rilievo;
    new ResizeObserver(() => disegna()).observe(cv);
    return disegna;
  }
  const angolo = (d) => { const e = (C.lunaLon(d) - C.soleLon(d)) % 360; return (e < 0 ? e + 360 : e) * Math.PI / 180; };
  /* Senza WebGL2 resta il disegno in SVG del tema */
  const metti = (posto, d = new Date()) => {
    if (!posto || !C) return null;
    const cv = document.createElement('canvas'); cv.className = 'kg-ess-luna'; cv.setAttribute('aria-hidden', 'true');
    posto.prepend(cv);
    const disegna = lunaIncisa(cv);
    if (!disegna) { cv.remove(); posto.classList.add('kg-ess-senza-luna'); return null; }
    disegna(angolo(d));
    return disegna;
  };

  /* Righe che si aprono */
  const apribile = (el) => {
    el.tabIndex = 0; el.setAttribute('role', 'button'); el.setAttribute('aria-expanded', el.classList.contains('kg-ess-aperta'));
    const scatta = (e) => { if (e.target.closest('a')) return; el.classList.toggle('kg-ess-aperta'); el.setAttribute('aria-expanded', el.classList.contains('kg-ess-aperta')); };
    el.addEventListener('click', scatta);
    el.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); scatta(e); } });
  };

  /* La fascia in home */
  const casa = $('.kg-luna--casa');
  if (casa) metti($('.kg-luna__quadrante', casa));

  /* La pagina della luna */
  const pagina = $('.kg-luna--pagina');
  if (pagina) {
    const disegna = metti($('.kg-luna__astro', pagina));
    const giorni = $('[data-kg-giorni]', pagina);
    if (disegna && giorni) new MutationObserver(() => {
      const k = $('.kg-giorno--scelto', giorni)?.dataset.giorno;
      if (k) { const d = new Date(`${k}T21:00:00`); if (!Number.isNaN(d.getTime())) disegna(angolo(d)); }
    }).observe(giorni, { subtree: true, attributes: true, attributeFilter: ['class'] });

    /* Le otto fasi, le feste e i segni arrivano dopo il primo disegno: si sistemano appena ci sono */
    const sistema = () => {
      $$('.kg-fase').forEach((f) => { if (f.dataset.kgEss) return; f.dataset.kgEss = '1'; apribile(f); });
      const s = $('.kg-fase--stanotte');
      if (s && !s.dataset.kgEssAperta) { s.dataset.kgEssAperta = '1'; s.classList.add('kg-ess-aperta'); s.setAttribute('aria-expanded', 'true'); }
      if (matchMedia('(max-width:749px)').matches) $$('.kg-segni__voce, .kg-festa').forEach((v) => { if (v.dataset.kgEss) return; v.dataset.kgEss = '1'; v.classList.add('kg-ess-piega'); apribile(v); });
    };
    sistema(); setTimeout(sistema, 1200); setTimeout(sistema, 3000); document.addEventListener('kg-luna:ora', sistema);

    /* Dai segni alla lettura astrologica */
    const segni = $('.kg-segni');
    if (segni && E.astroUrl) {
      const r = document.createElement('p'); r.className = 'kg-ess-astro-link';
      const a = document.createElement('a'); a.className = 'kg-luna__cta'; a.href = E.astroUrl;
      const sp = document.createElement('span'); sp.textContent = E.astroLink; a.append(sp); r.append(a); segni.after(r);
    }

    /* La ruota dell'anno, a inchiostro: il punto è dove sta il Sole oggi */
    const ruota = $('.kg-luna__ruota--grande');
    if (ruota && C) {
      const lon = C.soleLon(new Date()), punto = (g, r) => { const a = (g - 270 - 90) * Math.PI / 180; return [50 + r * Math.cos(a), 50 + r * Math.sin(a)]; };
      const tacche = [0, 45, 90, 135, 180, 225, 270, 315].map((g) => { const [x1, y1] = punto(g, 37), [x2, y2] = punto(g, 40); return `<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}"/>`; }).join('');
      const [sx, sy] = punto(lon, 38.5);
      ruota.insertAdjacentHTML('afterbegin', `<svg class="kg-ess-anello" viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="38.5" fill="none" stroke="#cfc3ab" stroke-width=".35"/><g stroke="#80612a" stroke-width=".35">${tacche}</g><circle cx="${sx}" cy="${sy}" r="1.5" fill="#4c1935"/></svg>`);
    }
  }

  /* Le carte: si torna alle guide, e a ogni passaggio la lettura riparte dall'alto */
  const kt = $('.kt');
  if (kt) {
    const metti_guida = () => { const b = $('.kt-back', kt); if (b && E.guideUrl) { b.href = E.guideUrl; const l = $('.kt-back-label', b); if (l && E.guide) l.textContent = E.guide; } };
    let passo = '', timer = 0;
    const leggi = () => {
      metti_guida();
      const ora = $('.kt-experience-exit', kt) ? `lettura:${$('.kt-panel:not([hidden]) h2', kt)?.textContent || ''}` : $('.kt-fan, .kt-reveal-screen', kt) ? 'tavolo' : 'domanda';
      if (ora !== passo) { const prima = passo; passo = ora; if (prima) kt.scrollIntoView({ block: 'start' }); }
    };
    leggi();
    new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(leggi, 120); }).observe(kt, { childList: true, subtree: true });
  }

  /* Dallo zodiaco alla lettura astrologica */
  const introZodiaco = E.zodiaco ? $('.kg-explore__intro') : null;
  if (introZodiaco && E.astroUrl) {
    const r = document.createElement('p'); r.className = 'kg-ess-astro-scopri';
    const a = document.createElement('a'); a.href = E.astroUrl; a.textContent = E.astroLink; r.append(a); introZodiaco.after(r);
  }

  /* Lettura astrologica: calcoli veri e testi già sul sito */
  const datiAstro = $('#kg-astro-dati');
  if (datiAstro && C) {
    const D = inChiaro(JSON.parse(datiAstro.textContent)), S = D.segni, F = D.fasi, T = D.t, ORD = Object.keys(S);
    const form = $('.kg-astro__form'), esito = $('.kg-astro__esito'), err = $('.kg-astro__errore');
    const segnoSole = (d) => ORD[Math.floor((((C.soleLon(d) % 360) + 360) % 360) / 30)];
    const faseDi = (d) => F[C.luna(d).chiave];
    const met = (s, m) => s.replace(/\[(\w+)\]/g, (x, k) => (k in m ? m[k] : x));
    const voce = (titolo, meta, testi, link) => {
      const a = document.createElement('article'); a.className = 'kg-astro__voce';
      const h = document.createElement('h2'); h.textContent = titolo; a.append(h);
      if (meta) { const p = document.createElement('p'); p.className = 'kg-astro__meta'; p.textContent = meta; a.append(p); }
      for (const t of testi) if (t) { const p = document.createElement('p'); p.textContent = t; a.append(p); }
      if (link?.length) { const p = document.createElement('p'); link.forEach(([u, n], i) => { if (i) p.append(' · '); const l = document.createElement('a'); l.href = u; l.textContent = n; p.append(l); }); a.append(p); }
      return a;
    };
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const dv = form.data.value, ov = form.ora.value;
      const sbaglio = !dv ? T.err_vuota : new Date(`${dv}T00:00:00`) > new Date() ? T.err_futuro : dv < '1900-01-01' ? T.err_antica : '';
      if (sbaglio) { err.textContent = sbaglio; err.hidden = false; esito.hidden = true; esito.replaceChildren(); return; }
      err.hidden = true;
      const quando = new Date(`${dv}T${ov || '12:00'}:00`);
      const a0 = new Date(`${dv}T00:00:00`), a1 = new Date(`${dv}T23:59:00`);
      const sole = segnoSole(quando), sole0 = segnoSole(a0), sole1 = segnoSole(a1), dubbioSole = !ov && sole0 !== sole1;
      const luna = C.segnoLuna(quando).segno, luna0 = C.segnoLuna(a0).segno, luna1 = C.segnoLuna(a1).segno, dubbioLuna = !ov && luna0 !== luna1;
      const f = faseDi(quando), oggi = C.segnoLuna(new Date()).segno, fOggi = faseDi(new Date());
      const fra = (x, y) => `${S[x].nome} ${T.o} ${S[y].nome}`;
      const blocchi = document.createElement('div'); blocchi.className = 'kg-astro__blocchi';
      const posto = document.createElement('div'); posto.className = 'kg-astro__luna';
      const lista = document.createElement('div'); lista.className = 'kg-astro__voci';
      lista.append(
        dubbioSole
          ? voce(met(T.sole, { segno: fra(sole0, sole1) }), met(T.cambia_sole, { a: S[sole0].nome, b: S[sole1].nome }), [S[sole0].sole, S[sole1].sole], [[S[sole0].url, S[sole0].nome], [S[sole1].url, S[sole1].nome]])
          : voce(met(T.sole, { segno: S[sole].nome }), `${S[sole].elemento} · ${S[sole].date}`, [S[sole].sole], [[S[sole].url, T.pezzi]]),
        dubbioLuna
          ? voce(met(T.luna, { segno: fra(luna0, luna1) }), met(T.cambia_luna, { a: S[luna0].nome, b: S[luna1].nome }), [S[luna0].luna, S[luna1].luna])
          : voce(met(T.luna, { segno: S[luna].nome }), S[luna].elemento, [S[luna].luna]),
        voce(met(T.nascita, { fase: f.name }), '', [f.line]),
        voce(met(T.stanotte, { segno: S[oggi].nome }), fOggi.name, [S[oggi].luna], [[E.lunaUrl, E.seguiLuna]]),
      );
      blocchi.append(posto, lista);
      const nota = document.createElement('p'); nota.className = 'kg-astro__nota'; nota.textContent = T.nota;
      esito.replaceChildren(blocchi, nota);
      esito.hidden = false;
      metti(posto, quando);
    });
  }
})();
